module.exports = __webpack_public_path__ + "92bdf7fa1dcf71ea056984d191102a0e.png";